import styled from 'styled-components'

import { TypeStyle, timingDefault } from '@syconium/little-miss-figgy'

export const Body = styled.div<{ isActive?: boolean }>`
  border: 1px solid
    ${o => (o.isActive ? o.theme.color.deprecated.obsidian : o.theme.color.deprecated.stoneLight)};
  border-radius: 6px;
  border-width: ${o => o.isActive && '2px'};
  box-sizing: border-box;
  transition: border-color ${timingDefault};
  max-height: 75vh;
  min-width: 100%;
  min-height: 100%;

  &:hover {
    border-color: ${o =>
      o.isActive ? o.theme.color.deprecated.obsidian : o.theme.color.deprecated.stoneDark};
  }
`

export const Figure = styled.figure`
  display: block;
  max-width: 100%;
  max-height: 100%;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;

  & > img {
    border-radius: 6px 6px 0 0;
    aspect-ratio: 7 / 9;
    object-fit: cover;
    min-width: 100%;
    display: block;
  }
`

export const Name = styled(TypeStyle.HeadlineExtraExtraSmall)`
  font-size: 14px;
  margin: 16px auto 12px;
`

export const Stat = styled.div`
  ${TypeStyle.css.bodySmall}
  font-size: 12px;
`

export const TextWrap = styled.div`
  padding: 0 12px 12px;
  text-align: center;
`
